<template>
  <div>
    <PageHeader
      :title="title"
      :isButton="true"
      :action="notificationForm"
      text="Add Notification Setting"
    />

    <b-card>
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="table-light">
            <tr>
              <th>Domain</th>
              <th>Type</th>
              <th>Email</th>
              <th>SMS</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>DV:52:E8:MC</td>
              <td>Fax</td>
              <td>akshaythummar109@gmail.com</td>
              <td>-</td>
              <td>
                <div class="form-check form-switch form-switch-md">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="status_id"
                  />
                </div>
              </td>
              <td>
                <i class="fas fa-pencil-alt ms-2 fs-5 text-success"></i>

                <i class="mdi mdi-trash-can ms-2 fs-4 text-danger"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>

    <Drawer
      @close="notificationForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openNotificationForm">
        <NotificationForm @cancelSubmit="notificationForm"></NotificationForm>
      </div>
    </Drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import Drawer from "@/components/drawer";

// Custom Components
import NotificationForm from "@/components/superAdmin/notificationAlert/notificationForm.vue";

export default {
  page: {
    title: "Notification Alert",
  },
  data() {
    return {
      title: "Notification Alert",
      openNotificationForm: false,
    };
  },
  components: {
    PageHeader,
    Drawer,
    NotificationForm,
  },
  methods: {
    notificationForm() {
      this.openNotificationForm = !this.openNotificationForm;
    },
  },
};
</script>
